<template>
	<div id="sentiment_popular_trend">
		<div class="row">
		</div>
		<!-- {{date1}} -->
		<v-chart-popular-trend ref="popularChart" :style="chartStyle" :options="line" :theme="echartsTheme" :key="echartsTheme" autoresize @datazoom='onDataZoom($event,line)'/>
		<b-alert show variant="light">
			<!-- <ul>
				<li></li>
			</ul> -->
		</b-alert>
	</div>
</template>
<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import Moment from 'moment'

	
	import {
		request_zzquant,
		// request_zrx
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	const downColor = '#00da3c';
	const downBorderColor = '#008F28';

		export default {
			props: {
				modal:String,
				title: {
					type: String,
					default: "市场人气热度"
				},
				subText: {
					type: String,
					default: "多日分时"
				},
				zoom_start: {
					type: [Number, String],
					default: 50,
				},
				zoom_end: {
					type: Number,
					default: 100,
				},
				chart_heigh: {
					type: String,
					default: '350px'
				},
				chart_width: {
					type: String,
					default: '100%'
				}
			},
			computed:{
				get_modal(){
					return new Number(this.modal)
				}
            ,chartStyle(){
                return { width: this.chart_width, height: this.chart_heigh }
            }
            ,echartsTheme(){ return this.theme==='dark' ? 'site-dark' : null }
			},
			watch:{
				chart_heigh(){
					this.$nextTick(()=>{this.resizeChart()})
				}
			},
		mounted() {
			// request_zrx({
			// 	url: '/v3/market/trade/days'
			// }).then(
			// 	res => {
			// 		let days = res.data.data;
			// 		this.date2 = days[days.length - 1];
			// 		this.date1 = days[0];
			// 	}
			// );
			//换时间范围
			this.date1 = Moment().add(-21,'days').format('YYYY-MM-DD'); 
			this.refresh();
			this.$nextTick(()=>{this.resizeChart()})
			try{
				const t = localStorage.getItem('site.theme');
				if(t){
					this.theme = t
				}
			}catch(e){console.log(e)}
			window.addEventListener('site-theme-changed', this.onThemeChanged)
			// this.timer = setInterval(() => { //创建定时器
			// 	// this.refresh_intervel();
			// }, 6000);
		},
		components: {
			'v-chart-popular-trend': ECharts
		},
		data() {
			// const now = new Date();
			// const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
			let today = Moment().format("YYYY-MM-DD")
			return {
				reqId: 0,
				theme:'light',
				auto_refresh: 0,
				date1: today,
				date2: today,
				timer: null, //首先我在data函数里面进行定义定时器名称
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0,
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							var h = params[0].name + " <br />";
							params.forEach((item) => {
								var v = "";
								if (item.seriesName === '情绪') {
									v = item.seriesName + ": " + item.value + "%<br/>";
								} else if (item.seriesName === '成交额') {
									v = item.seriesName + ": " + (item.value[1] / 100000000).toFixed(2) + "亿<br/>";
								} else {
									v = item.seriesName + ": " + item.value + "<br/>";
								}
								h += v;
							});
							return h;
						}
					},
					toolbox: { //下载
						show: true,
						feature: {
							saveAsImage: {}
						}
					},
					legend: {
						top: 10,
						left: 'center',
						data: ['情绪', '成交额'],
						textStyle: {
							color: '#999999'
						},
					},
					axisPointer: {
						link: { xAxisIndex: 'all' }
					},
					color: [upColor],
					visualMap: {
						// top: 10,
						// right: 10,
						type: 'piecewise',
						show: false,
						seriesIndex: [0],
						dimension: 1,
						pieces: [{
								min: parseFloat(0),
								max: parseFloat(1),
								color: upColor
							},
							{
								min: parseFloat(1.01),
								max: parseFloat(10),
								color: upBorderColor
							},
							{
								min: parseFloat(-2),
								max: parseFloat(0),
								color: downColor
							},
							{
								min: parseFloat(-10),
								max: parseFloat(-2),
								color: downBorderColor
							},
						],
						outOfRange: {
							symbol: 'rect',
							symbolSize: [1, 1],
							color: upBorderColor,
						}
					},
					grid: [
						{
							left: '5%',
							right: '5%',
							top: '10%',
							height: '55%'
						},
						{
							left: '5%',
							right: '5%',
							top: '70%',
							height: '15%'
						}
					],
					xAxis: [
						{
							gridIndex: 0,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								interval: 1,
								color: '#999999',
								formatter: function(value) {
									return value.substring(11,16) === '09:30' ||value.substring(11,16) === '09:31' ? value.substring(0,11) : ""
								}
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: { onZero: false, lineStyle: { color: '#666666' } },
							axisTick: { show: false },
							splitLine: { show: false },
							axisLabel: { show: false },
							min: 'dataMin',
							max: 'dataMax'
						}
					],
					yAxis: [
						{
							gridIndex: 0,
							name: "情绪",
							scale: true,
							position: 'left',
							min: function(value) {
								return value.min > -5 ? -5 : value.min
							},
							max: function(value) {
								return value.max < 5 ? 5 : value.max
							},
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}%',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
						{
							gridIndex: 0,
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: false,
							position: 'right',
						},
						{
							gridIndex: 1,
							scale: true,
							splitNumber: 2,
							axisLabel: { show: false },
							axisLine: { show: false },
							axisTick: { show: false },
							splitLine: { show: false },
							position: 'right'
						}
					],
					dataZoom: [
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: this.zoom_start,
							end: this.zoom_end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				},
				mark_line_data:[{
					// silent: false,
					lineStyle: { //警戒线的样式  ，虚实  颜色
						width: 1,
						type: "solid",
						symbol: 'circle',
						color: upBorderColor,
					},
					label: {
						position: 'end',
						formatter: "沸腾"
					},
					yAxis: 3
				},
				{
					// silent: false,
					lineStyle: { //警戒线的样式  ，虚实  颜色
						width: 1,
						type: "dotted",
						symbol: 'circle',
						color: upColor,
					},
					label: {
						position: 'end',
						formatter: "活跃"
					},
					yAxis: 1
				},
				{
					// silent: false,
					lineStyle: { //警戒线的样式  ，虚实  颜色
						type: "dashed",
						color: "#AAA",
					},
					label: {
						position: 'end',
						formatter: "及格"
					},
					yAxis: 0
				},
				{
					// silent: false,
					lineStyle: { //警戒线的样式  ，虚实  颜色
						type: "dashed",
						symbol: 'circle',
						color: downBorderColor,
					},
					label: {
						position: 'end',
						formatter: "冰凉"
					},
					yAxis: -2
				},
				{
					// silent: false,
					lineStyle: { //警戒线的样式  ，虚实  颜色
						width: 1,
						type: "solid",
						color: downBorderColor,
					},
					label: {
						position: 'end',
						formatter: "冰点"
					},
					yAxis: -4
				}
			]
			}
        },
		methods: {
			clearTimer() { //清除定时器
				clearInterval(this.timer);
				this.timer = null;
			},
			refresh_intervel() {
				if (this.auto_refresh) {
					let myDate = new Date();
					let day = myDate.getDay() //获取当前星期X(0-6,0代表星期天)
					let hour = myDate.getHours(); //获取当前小时数(0-23)
					if (0 < day && day < 6 && 9 <= hour && hour <= 15) {
						this.refresh();
					} else {
						console.log("trend 非交易时间不刷新");
					}
				}
			},
			onDatePicked(ctx) {
				// console.log(ctx.selectedYMD);
				this.date1 = ctx.selectedYMD;
				this.refresh();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			refresh() {
				const curReqId = ++this.reqId;
				const curReqDate = this.date1;
				let date1 = this.date1;
				let url = 'v3/api/sentiment/trend/'+this.modal+'/range?date1=' + date1;
				axios.all([
						request_zzquant({
							'url': url,
						})
					])
					.then(axios.spread((resp1) => {
						if (curReqId !== this.reqId || curReqDate !== this.date1) return;
						let rawData = resp1 && resp1.data && resp1.data.data;
						let splitDataItem = this.splitData(rawData);
						let series_data = []
						series_data.push({
							name: '情绪',
							data: splitDataItem.pct,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							xAxisIndex: 0,
							yAxisIndex: 0, // 对应上面定义的y轴数据的格式，数组的下标进行对应
							markLine: {
								symbol:'none',//去掉箭头
								data: this.mark_line_data
							},
							lineStyle: {
								normal: {
									width: 1,
									opacity: 1,
								}
							},
						});

						series_data.push({
							name: '成交额',
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 2,
							data: splitDataItem.volumes,
							itemStyle: {
								normal: {
									color: function(params) {
										var colorList;
										if (params.data[2] > 0) {
											colorList = upColor;
										} else {
											colorList = downColor;
										}
										return colorList;
									}
								}
							}
						});

						this.line['xAxis'][0].data = splitDataItem.categoryData;
						this.line['xAxis'][1].data = splitDataItem.categoryData;
						this.line['series'] = series_data;
						this.$nextTick(()=>{this.resizeChart()})
					}))
					.catch(err => {
						if (curReqId === this.reqId) {
							console.log(err);
						}
					})
			},
			resizeChart(){
				if(this.$refs && this.$refs.popularChart && typeof this.$refs.popularChart.resize==='function'){
					this.$refs.popularChart.resize()
				}
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis.data[0])
						if(data_start < Moment(this.date1)){
							return
						}
						this.date1 = data_start.add(-1,'months').format("YYYY-MM-DD")
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh()
					}
					
				}
			},
			splitData(rawData) {
				let [categoryData, pct, volumes] = [
					[],
					[],
					[]
				]; //解构赋值
				if (!Array.isArray(rawData)) {
					return {
						categoryData,
						pct,
						volumes
					};
				}
				rawData.forEach((item, index) => {
					let item_date = item[0] + ' ' + item[1]
					categoryData.push(item_date);
					pct.push(item[2]);
					
					let amount = item.length > 3 ? item[3] : 0;
					let prevPct = index > 0 ? rawData[index-1][2] : 0;
					let direction = item[2] >= prevPct ? 1 : -1;
					volumes.push([index, amount, direction]);

					if(item[1]=='09:31:00'){
						this.mark_line_data.push(
						{xAxis:item_date,
						label: {formatter: item[0].substr(5)},
						lineStyle: { //警戒线的样式  ，虚实  颜色
							type: "dashed",
							color: "#AAA",
						},	
						})
					}
				})
				return {
					categoryData: categoryData,
					pct: pct,
					volumes: volumes
				};
			}
		},
        
        beforeDestroy(){ 
            window.removeEventListener('site-theme-changed', this.onThemeChanged)
            clearInterval(this.timer);
            this.timer = null;
        },
        created(){ this.onThemeChanged = (e)=>{ const t = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = t; this.$nextTick(()=>{ this.resizeChart() }) } }
	}
</script>

<style scoped>
.chart_popular_trend {
	width: 100% !important;
	height: 350px !important;
}
.chart_popular_trend_high {
	width: 100% !important;
	height: 420px !important;
}
</style>
